import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { ReduceStore } from 'flux/utils';

class CourseTrainerStore extends ReduceStore {

    getInitialState() {
        return [];
    }

    getByCourse(id) {
        const courseId = Number(id);
        return this.getState().filter(function(e) { return e !== undefined && e.courseId === courseId; });
    }
    
    reduce(state, action) {
        let data;
        switch (action.type) {
            case ActionTypes.COURSE_TRAINER_LIST_SUCCESS:
                const courseId = Number(action.payload.courseId);
                data = this.getState().filter((trainer) => (!!trainer && trainer.courseId !== courseId));
                action.data.forEach((trainer) => {
                    let courseTrainer = Object.assign({}, trainer, {courseId});
                    data.push(courseTrainer);
                });
                return data;

            default:
                return state;
        }
    }
}

export default new CourseTrainerStore(CentricDispatcher);
